import { render, staticRenderFns } from "./CampaignContent.vue?vue&type=template&id=71793f5b&scoped=true"
import script from "./CampaignContent.vue?vue&type=script&lang=js"
export * from "./CampaignContent.vue?vue&type=script&lang=js"
import style0 from "./CampaignContent.vue?vue&type=style&index=0&id=71793f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71793f5b",
  null
  
)

export default component.exports